<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9.8,4C9.8,4,11,4,11,4C11.5,4,12,3.6,12,3C12,2.4,11.6,2,11,2C11,2,7,2,7,2C6.5,2,6,2.4,6,3C6,3.6,6.4,4,7,4C7,4,7.8,4,7.8,4C7.8,4,6.2,12,6.2,12C6.2,12,5,12,5,12C4.5,12,4,12.4,4,13C4,13.6,4.4,14,5,14C5,14,9,14,9,14C9.5,14,10,13.6,10,13C10,12.4,9.6,12,9,12C9,12,8.2,12,8.2,12C8.2,12,9.8,4,9.8,4C9.8,4,9.8,4,9.8,4Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Italic',
} as DefineComponent
</script>
